import { API_URL } from 'constants';

export const generateAbsenceCreateURL = (employeeId) => {
    return `${API_URL}/api/v1/absence/employee/${employeeId}/absencetype`;
};

export const generateAdminAbsenceCreateURL = (employeeId) => {
    return `${API_URL}/api/v1/absence/admin/employee/${employeeId}/absencetype`;
};

export const CANCEL_ABSENCE_URL = `${API_URL}/api/v1/absence`;

export const generateAdminCancelAbsenceURL = (absenceId) => {
    return `${CANCEL_ABSENCE_URL}/${absenceId}/admin-cancel`;
};

export const GET_ABSENCES_URL = `${API_URL}/api/v1/absence/employee`;
